import React from 'react'

import { FSDeclineButtons, FSEndButtons, FSMainButtons } from '@components'
import { BonusSystemState, BonusSystemDeclineState, Bonus } from 'game-ui-types'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'

interface FSFooterProps {
    bonus?: Bonus
}

const FSFooter: React.FC<FSFooterProps> = ({ bonus }: FSFooterProps) => {
    const bonusSystemState = useFreeSpinsBonusesStore((state) => state.bonusSystemState)
    const bonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.bonusSystemDeclineState)

    const isInMainState =
        bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL ||
        bonusSystemState === BonusSystemState.MULTIPLE_BONUSES_INITIAL
    const isInDeclineState =
        bonusSystemDeclineState === BonusSystemDeclineState.SINGLE_BONUS_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.MULTIPLE_BONUSES_DECLINE ||
        bonusSystemDeclineState === BonusSystemDeclineState.BUNDLE_DECLINE
    const isInEndState = bonusSystemState === BonusSystemState.END

    if (isInMainState && !isInDeclineState) {
        return <FSMainButtons bonus={bonus} />
    } else if (isInDeclineState) {
        return <FSDeclineButtons bonus={bonus} />
    } else if (isInEndState) {
        return <FSEndButtons />
    }
}

export default FSFooter
